import { TZGraph } from '@/utils/ZGraph.js'
import { TZMathFunct } from '@/utils/ZMathFunct.js'

class TZGraphPiezoSingoloDato 
{
  constructor(Data, Profondita, Colore, ScritteVisibili, GraphVisibile = true)
  {
    this.Data             = Data;
    this.Profondita       = Profondita;
    this.Colore           = Colore;
    this.ScritteVisibili  = ScritteVisibili;
    this.GraphVisibile    = GraphVisibile;
  }
}

class TZGraphPiezometroSingoloDato 
{
  constructor(Colore, ScritteVisibili, NumeroPiezometro, Profondita, PosizionePiezometro, PressionePiezometro, Data, MostraInfoPiezometro, GraphVisibile = true, MostraSoloHint)
  {
    this.Colore               = Colore;
    this.ScritteVisibili      = ScritteVisibili;
    this.NumeroPiezometro     = NumeroPiezometro;
    this.Profondita           = Profondita;
    this.PosizionePiezometro  = PosizionePiezometro;
    this.PressionePiezometro  = PressionePiezometro;
    this.Data                 = Data;
    this.GraphVisibile        = GraphVisibile;
    this.MostraInfoPiezometro = MostraInfoPiezometro
    this.MostraSoloHint       = MostraSoloHint
    this.__Markup             = null;
    this.__MarkupHighlighted  = null;
  }
}

class TZGraphPackerSingoloDato 
{
  constructor(Descrizione, DallaProfondita, AllaProfondita, Colore)
  {
    this.Descrizione     = Descrizione;
    this.DallaProfondita = DallaProfondita;
    this.AllaProfondita  = AllaProfondita;
    this.Colore          = Colore;
  }
}

export class TZGraphPiezometria extends TZGraph
{
  constructor(Canvas)
  {
    super(Canvas)
    this.COLORE_TESTO           = '#007fff'
    this.COLORE_COLONNA         = '#F0F8FF'
    this.DrawMarkup             = true
    this.MediaDisegnata         = false
    this.ColonnaMediaDisegnata  = false
    this.ShowMedia              = true
    this.UltimaData             = null
    this.MaxLabelWidth          = this.__Context.measureText("m pc").width
    this.ListaPressioni         = []
    this.ListaPressioniVisibili = []
  }

  AddPiezoInfo(Data,Profondita,Colore,ScritteVisibili, GraphVisibile)
  {
    this.ListaPressioni.push(new TZGraphPiezoSingoloDato(Data, Profondita, Colore, ScritteVisibili, GraphVisibile))
  }

  ClearPiezoInfo()
  {
    this.ListaPressioni = []
  }

  Paint()
  {
    this.__CalculateMargins()
    let MinX = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
    let MinY = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let MaxX = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
    let MaxY = this.__GetYPixelsFromRealUdm(this.AxisY.Max)    

    const TEXT_DIMENSION  = 1.5
    const ENLARGE_GRAPHIC = TEXT_DIMENSION * 1.3
    const MAX_NUMERO_COLONNE = 4
    // const COLORE_DEFAULT = '#dfdfdf'
    
    this.__Context.clearRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = this.Background
    this.__Context.fillRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = 'transparent'
    this.DrawYQuote() //Mostra i numeri sull'asse Y
    this.MisuraMaxLabelWidth()
    this.__DrawLeftSideLabels() //Mostra la scritta sull'asse Y
    this.__DrawBottomSideLabels()
    this.ListaPressioniVisibili = []

    this.ListaPressioni.forEach(
                                  (Pressione)=> {
                                                  if(Pressione.GraphVisibile && Pressione.ScritteVisibili)
                                                    this.ListaPressioniVisibili.push(Pressione)
                                                }
                               );
    
    for(let i = 0; i < this.ListaPressioniVisibili.length; i++)
    {
      if(i < MAX_NUMERO_COLONNE)
      {
        let NumeroColonne = this.ListaPressioniVisibili.length <= MAX_NUMERO_COLONNE ? this.ListaPressioniVisibili.length : MAX_NUMERO_COLONNE
        this.DrawAllGraphs(MinX, MaxX, MinY, ENLARGE_GRAPHIC, TEXT_DIMENSION, this.COLORE_TESTO, i, NumeroColonne, MAX_NUMERO_COLONNE) //Mostra numeri e simbolo
        if(!this.MediaDisegnata && !this.ShowMedia)
        {
          this.DrawColonnaPiezometrica(MinX, MinY, MaxX, MaxY, ENLARGE_GRAPHIC, i, NumeroColonne) //Mostra la colonna centrale
        }
      }
    }

    if(!this.MediaDisegnata && this.ShowMedia && !this.ColonnaMediaDisegnata)
    {
      this.DrawAllGraphs(MinX, MaxX, MinY, ENLARGE_GRAPHIC, TEXT_DIMENSION, this.COLORE_TESTO, 0, 0, MAX_NUMERO_COLONNE)
      
      let NumeroColonne = 1
      if(this.ListaPressioni.length > 1)
      {
        for (let i = 1; i < this.ListaPressioni.length; i++) 
        {
          if (this.ListaPressioni[i].GraphVisibile && this.ListaPressioni[i].Data != this.ListaPressioni[i-1].Data && NumeroColonne < MAX_NUMERO_COLONNE) 
            NumeroColonne += 1;
        }
      }
      
      for (let j = 0; j < NumeroColonne; j++) 
      {
        this.DrawColonnaPiezometrica(MinX, MinY, MaxX, MaxY, ENLARGE_GRAPHIC, j, NumeroColonne)
      }
    }

    this.MediaDisegnata = false
    this.ColonnaMediaDisegnata = false

    this.DrawAllBorders() //Disegna i bordi
    this.__DrawGrid(MinX, MaxX) //Disegna le linee tratteggiate
  }

  MisuraMaxLabelWidth()
  {
    for (let i = 0; i < this.ListaPressioni.length; i++)
    { 
      let LSPressioni = this.ListaPressioni[i]
      let Label = parseFloat((LSPressioni.Profondita).toFixed(2))
      if (LSPressioni.ScritteVisibili == true && this.__Context.measureText(Label * -1).width > this.MaxLabelWidth)
        this.MaxLabelWidth = this.__Context.measureText(Label * -1).width
    }
  }

   __DrawGrid(MinX, MaxX)
  {
    this.AxisY.NotchPenStyle = [5,5]
    this.__DrawYNotches(MinX, MaxX)
    this.AxisY.NotchPenStyle = [0,0]
    this.__Context.setLineDash(this.AxisY.NotchPenStyle) 
  }

  __SceltaColore(Indice)
  {
    let UltimaData = this.UltimaData.Data
    if(this.ListaPressioniVisibili.length == 1 && this.ListaPressioniVisibili[Indice].Data === UltimaData)
    {
      return true
    }
    return false
  }

  DrawAllGraphs(MinX, MaxX, MinY, ENLARGE_GRAPHIC, TEXT_DIMENSION, COLORE_TESTO, Indice, NumeroColonne, MAX_NUMERO_COLONNE)
  {
    let TestoVisibile  = true
    if (this.ListaPressioniVisibili.length > 0)
    {
      let LSPressioni = this.ListaPressioniVisibili[Indice]
      if (LSPressioni.GraphVisibile)
      {
        LSPressioni.Profondita = parseFloat((LSPressioni.Profondita).toFixed(2))      
        this.__Context.strokeStyle = LSPressioni.Colore
        if (LSPressioni.ScritteVisibili)
        {
          this.__DrawLivelloAcqua(MinX, MaxX, (LSPressioni.Profondita < 0) ? 0 : LSPressioni.Profondita, MinY, ENLARGE_GRAPHIC, TestoVisibile, Indice, NumeroColonne)
          this.__DrawValueGraph(LSPressioni.Profondita, MinX, MaxX, LSPressioni.Colore, TestoVisibile, ENLARGE_GRAPHIC, TEXT_DIMENSION, !this.__SceltaColore(Indice) ? LSPressioni.Colore : COLORE_TESTO, Indice, NumeroColonne, LSPressioni.Profondita < 0)
          this.ShowMedia  = false
          TestoVisibile   = false
        }
      }
    }
    
    if (this.ListaPressioni.length > 0)
    {
      let MediaPressioni = this.ListaPressioni[0].Profondita
      let Contatore      = 1
      let Colore         = this.AxisX.Color
      if (this.ShowMedia && !this.MediaDisegnata)
      {
        NumeroColonne = 1
        Indice = 1

        if(this.ListaPressioni.length > 1)
        {
          for (let i = 1; i < this.ListaPressioni.length; i++) 
          {
            if (this.ListaPressioni[i].GraphVisibile && this.ListaPressioni[i].Data != this.ListaPressioni[i-1].Data && NumeroColonne < MAX_NUMERO_COLONNE) 
              NumeroColonne += 1;
          }

          for (let i = 1; i < this.ListaPressioni.length; i++)
          {
            let LSPressioni = this.ListaPressioni[i]
            if (LSPressioni.GraphVisibile)
            {
              if (this.ListaPressioni[i].Data != this.ListaPressioni[i-1].Data)
              {
                if(Indice < MAX_NUMERO_COLONNE)
                {
                  MediaPressioni  = (MediaPressioni / Contatore).toFixed(2)
                  this.__DrawLivelloAcquaPiezo(MinX, MaxX, (MediaPressioni < 0) ? 0 : MediaPressioni, MinY, ENLARGE_GRAPHIC, TestoVisibile, Indice, NumeroColonne)
                  this.__DrawValueGraph(MediaPressioni, MinX, MaxX, Colore, TestoVisibile, ENLARGE_GRAPHIC, TEXT_DIMENSION, !this.__SceltaColore(Indice) ? LSPressioni.Colore : COLORE_TESTO, Indice, NumeroColonne, MediaPressioni < 0)
                }
                MediaPressioni     = 0
                Contatore          = 0
                Indice++
              }

              MediaPressioni += LSPressioni.Profondita
              Contatore      += 1
              Colore          = LSPressioni.Colore
            }  
          } 
        }
        
        Indice = 0
        MediaPressioni = (MediaPressioni / Contatore).toFixed(2)  
        this.__DrawLivelloAcquaPiezo(MinX, MaxX, (MediaPressioni < 0) ? 0 : MediaPressioni, MinY, ENLARGE_GRAPHIC, TestoVisibile, Indice, NumeroColonne)
        this.__DrawValueGraph(MediaPressioni, MinX, MaxX, Colore, TestoVisibile, ENLARGE_GRAPHIC, TEXT_DIMENSION, NumeroColonne > 1 ? this.ListaPressioni[0].Colore : COLORE_TESTO, Indice, NumeroColonne, MediaPressioni < 0)

        this.MediaDisegnata = true
      }
    }
  }

  __DrawValueGraph(Profondita, MinX, MaxX, Colore, TestoVisibile, ENLARGE_GRAPHIC, TEXT_DIMENSION, COLORE_TESTO, Indice, NumeroColonne, GraficoSopraMpc = false)
  {
    this.__Context.save()
    let LabelUdm         = "m pc"
    //let LabelSimbolo     = "\u25BC"
    const ROW_HEIGHT       = this.AxisY.FontSize * TEXT_DIMENSION / 1.5
    let ProfonditaSopraMpc = Profondita
    if(GraficoSopraMpc)
      ProfonditaSopraMpc = 0
    let YCoordProfondita = this.__GetYPixelsFromRealUdm(ProfonditaSopraMpc)
    this.__Context.beginPath()
    this.__Context.strokeStyle = Colore
    if ((YCoordProfondita < (this.__Canvas.height - this.__Margins.Bottom) && YCoordProfondita > this.__Margins.Top) || GraficoSopraMpc)
    {
      // Cominciano le linee orizzontali
      // this.__Context.moveTo(MinX, YCoordProfondita)
      // this.__Context.lineTo((MinX + MaxX) / 2 - (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC, YCoordProfondita)
      // this.__Context.moveTo((MinX + MaxX) / 2 + (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC, YCoordProfondita)
      // this.__Context.lineTo(MaxX, YCoordProfondita)
      // this.__Context.stroke()
      //Finiscono le linee
      
      //let XCoordCenter = (MinX + MaxX) / 2
      
      let SpazioDisponibile = MaxX - MinX;
      let TotaleColonne = NumeroColonne + 1;
      let DistanzaTraColonne = SpazioDisponibile / TotaleColonne

      let XCoordCenter = MinX + DistanzaTraColonne * ( Indice + 1 )
      
      if (TestoVisibile)
      {
        //let MisureSimbolo = this.__Context.measureText(LabelSimbolo) 
        let FontSize = this.__GetTextDimension(this.AxisY.FontSize * TEXT_DIMENSION, ENLARGE_GRAPHIC, LabelUdm, " " + (ProfonditaSopraMpc * -1) + " ")

        //Serviva a far adattare il testo allo zoom
        // if (this.PiezoFontZoom != null)
        // {
        //   FontSize   *= this.PiezoFontZoom
        //   ROW_HEIGHT *= this.PiezoFontZoom
        // }

        this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType)
        this.__Context.fillStyle = COLORE_TESTO
        //this.__Context.fillText(LabelSimbolo, XCoordCenter - (this.__Context.measureText(LabelSimbolo).width / 2), YCoordProfondita + MisureSimbolo.fontBoundingBoxAscent)
        this.DrawSimbol(this.LabelSimbolo(MinX, MaxX, ProfonditaSopraMpc, ENLARGE_GRAPHIC, Indice, NumeroColonne), COLORE_TESTO, TEXT_DIMENSION)

        this.__Context.textAlign = "left"; 
        this.__Context.textBaseline = "top";
        this.__Context.fillText(LabelUdm, XCoordCenter - (this.__Context.measureText(LabelUdm).width / 2), YCoordProfondita - ROW_HEIGHT - 2)
        let TextProfondita = " -" + Number(Profondita).toFixed(2) + " "
        if(Profondita < 0)
          TextProfondita = " +" + (Profondita * -1).toFixed(2) + " "
        this.__Context.fillText(TextProfondita, XCoordCenter - (this.__Context.measureText(TextProfondita).width / 2), YCoordProfondita - 1.8 * ROW_HEIGHT - 2 )
      }
      
    }
    this.__Context.restore()
  }
  __GetTextDimension(FontSize, ENLARGE_GRAPHIC, Label, Profondita)
  {
    let DimensioneColonna =  (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC
    
    this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType)

    while(this.__Context.measureText(Label).width > DimensioneColonna)
    {
      if(FontSize < 5)
        break
      FontSize -= 1
      this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType)
    }

    while(this.__Context.measureText(Profondita).width > DimensioneColonna)
    {
      if(FontSize < 5)
        break
      FontSize -= 1
      this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType)
    }
    
    FontSize += 1
    this.__Context.font = this.__GetFont(FontSize, this.AxisY.FontType)

    return FontSize
  }

  LabelSimbolo(MinX, MaxX, Profondita, ENLARGE_GRAPHIC, Indice, NumeroColonne)
  {
    let Simbolo = []

    let SpazioDisponibile = MaxX - MinX;
    let TotaleColonne = NumeroColonne + 1;
    let DistanzaTraColonne = SpazioDisponibile / TotaleColonne

    let XCoordCenter = MinX + DistanzaTraColonne * ( Indice + 1 )

    //let XCoordCenter    = (MinX + MaxX) / 2
    let CoordXIniziale = XCoordCenter - (this.MaxLabelWidth / 4) * ENLARGE_GRAPHIC
    let CoordYIniziale = this.__GetYPixelsFromRealUdm(Profondita)
    let CoordXFinale = XCoordCenter + (this.MaxLabelWidth / 4) * ENLARGE_GRAPHIC
    let Step = 4

    let Lunghezza = CoordXFinale - CoordXIniziale
    let YStep = Lunghezza / (Step * 2);

    for(let i = 0; i < 4; i++)
    {
      let LunghezzaCorrente = Lunghezza * (1 - i / Step) - Step;
      let Meta = LunghezzaCorrente / 2;
      
       Simbolo.push({
                        X1: XCoordCenter - Meta,
                        Y1: CoordYIniziale + i * YStep,
                        X2: XCoordCenter + Meta,
                        Y2: CoordYIniziale + i * YStep
                    });

    }

    return Simbolo

  }

  DrawSimbol(Simbolo, Colore)
  {
    Simbolo.forEach(Coordinata => {
                                    this.__Context.beginPath()
                                    //this.__Context.font = this.__GetFont(this.AxisY.FontSize * TEXT_DIMENSION, this.AxisY.FontType)
                                    this.__Context.moveTo(Coordinata.X1, Coordinata.Y1);
                                    this.__Context.lineTo(Coordinata.X2, Coordinata.Y2);
                                    this.__Context.strokeStyle = Colore
                                    this.__Context.lineWidth = 2;
                                    this.__Context.stroke();
                                  })
  }

  DrawAllBorders()
  {
    this.__Context.beginPath()
    this.__Context.strokeStyle = this.AxisX.Color
    this.__Context.setLineDash(this.AxisX.PenStyle)
    this.__Context.moveTo(this.__Margins.Left, this.__Margins.Top)
    this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Margins.Top)
    this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Canvas.height - this.__Margins.Bottom)
    this.__Context.lineTo(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom) 
    this.__Context.lineTo(this.__Margins.Left, this.__Margins.Top)
    this.__Context.stroke()
  }

  DrawYQuote()
  {
    this.__Context.beginPath()
    let CurrentNotch = 0
    
    while (this.AxisY.Min > CurrentNotch)
    {      
      let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
      if( StartPx >= this.__Margins.Top - 1)
        this.__DrawYAxisLabel(CurrentNotch)
      CurrentNotch += this.AxisY.NotchDim
    }
  }

  DrawColonnaPiezometrica(MinX, MinY, MaxX, MaxY, ENLARGE_GRAPHIC, Indice, NumeroColonne)
  {
    this.__Context.strokeStyle = '#000'
    
    let SpazioDisponibile = MaxX - MinX;
    let TotaleColonne = NumeroColonne + 1;
    let LarghezzaColonna = (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC 
    let DistanzaTraColonne = SpazioDisponibile / TotaleColonne

    let XCoordCenter = MinX + DistanzaTraColonne * ( Indice + 1 )

    let FirstPositionX  = XCoordCenter - LarghezzaColonna/2
    let SecondPositionX = XCoordCenter + LarghezzaColonna/2
    
    //let XCoordCenter    = (MinX + MaxX) / 2
    // let FirstPositionX  = XCoordCenter - (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC
    // let SecondPositionX = XCoordCenter + (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC
    this.__Context.beginPath()
    this.__Context.moveTo(FirstPositionX, MinY)
    this.__Context.lineTo(FirstPositionX, MaxY)
    this.__Context.moveTo(SecondPositionX, MinY)
    this.__Context.lineTo(SecondPositionX, MaxY)
    this.__Context.stroke()
  }

  __DrawLivelloAcqua(MinX, MaxX, Profondita, MaxY, ENLARGE_GRAPHIC, TestoVisibile, Indice, NumeroColonne)
  {
    if (TestoVisibile && this.ListaPressioniVisibili.length > 0)
    {
      let SpazioDisponibile = MaxX - MinX;
      let TotaleColonne = NumeroColonne + 1;
      let LarghezzaColonna = (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC 
      let DistanzaTraColonne = SpazioDisponibile / TotaleColonne

      let XCoordCenter = MinX + DistanzaTraColonne * ( Indice + 1 )

      let FirstPositionX  = XCoordCenter - LarghezzaColonna/2
      let SecondPositionX = XCoordCenter + LarghezzaColonna/2
      
      // let XCoordCenter = (MinX + MaxX) / 2
      // let FirstPositionX = XCoordCenter - (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC
      // let SecondPositionX = XCoordCenter + (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC

      let YCoordProfondita = this.__GetYPixelsFromRealUdm(Profondita)

      let Larghezza = SecondPositionX - FirstPositionX
      let Altezza = MaxY - YCoordProfondita
      this.__Context.fillStyle = this.COLORE_COLONNA

      this.__Context.fillRect(FirstPositionX, YCoordProfondita, Larghezza, Altezza)
    }
  }

  __DrawLivelloAcquaPiezo(MinX, MaxX, Profondita, MaxY, ENLARGE_GRAPHIC, TestoVisibile, Indice, NumeroColonne)
  {
    if (TestoVisibile && this.ListaPressioni.length > 0)
    {
      let SpazioDisponibile = MaxX - MinX;
      let TotaleColonne = NumeroColonne + 1;
      let LarghezzaColonna = (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC 
      let DistanzaTraColonne = SpazioDisponibile / TotaleColonne

      let XCoordCenter = MinX + DistanzaTraColonne * ( Indice + 1 )

      let FirstPositionX  = XCoordCenter - LarghezzaColonna/2
      let SecondPositionX = XCoordCenter + LarghezzaColonna/2
      
      // let XCoordCenter = (MinX + MaxX) / 2
      // let FirstPositionX = XCoordCenter - (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC
      // let SecondPositionX = XCoordCenter + (this.MaxLabelWidth / 2) * ENLARGE_GRAPHIC

      let YCoordProfondita = this.__GetYPixelsFromRealUdm(Profondita)

      let Larghezza = SecondPositionX - FirstPositionX
      let Altezza = MaxY - YCoordProfondita
      this.__Context.fillStyle = this.COLORE_COLONNA

      this.__Context.fillRect(FirstPositionX, YCoordProfondita, Larghezza, Altezza)
    }
  }
}

export class TZGraphPacker extends TZGraph
{
  constructor(Canvas)
  {
    super(Canvas)
    this.DrawMarkup  = true;
    this.ListaPiezometri = []
    this.ShiftGrafico    = 0
    this.EdgeGrafico     = 0
    this.DimensioneTesto = 0
    //this.COLORE_DESCRIZIONE_PACKER = '#CC33FF'
    this.COLORE_AZZURRO = '#007fff'
    this.UltimaData = null
    this.Ingrandito = false
    this.DatiSopraLivelloCampagna = false
    this.ListaPiezometriVisibili = []
  }

  AddPiezometroInfo(Colore, ScritteVisibili, NumeroPiezometro, Profondita, PosizionePiezometro, PressionePiezometro, Data, MostraInfoPiezometro, MostraSoloHint = false)
  {
    this.ListaPiezometri.push(new TZGraphPiezometroSingoloDato(Colore, ScritteVisibili, NumeroPiezometro, Profondita, PosizionePiezometro, PressionePiezometro, Data, MostraInfoPiezometro, true, MostraSoloHint))
  }

  AddPackerInfo(Descrizione, DallaProfondita, AllaProfondita, Colore)
  {
    this.ListaPacker.push(new TZGraphPackerSingoloDato(Descrizione, DallaProfondita, AllaProfondita, Colore))
  }

  ClearPiezoInfo()
  {
    this.ListaPiezometri = [],
    this.ListaPacker = []
  }

  Paint()
  {
    this.__CalculateMargins()
    let MinX                 = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
    let MinY                 = this.__GetYPixelsFromRealUdm(this.AxisY.Min)
    let MaxX                 = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
    // let MaxY                 = this.__GetYPixelsFromRealUdm(this.AxisY.Max)
    let MaxY                 = this.__GetYPixelsFromRealUdm(0)
    const CENTER             = (MinX + MaxX) / 2    
    const CENTER_EDGE        = (MinX + MaxX) / 32
    const TEXT_DIMENSION     = 1
    const GRAPH_SHIFT        = this.__GetDimensioneShift(CENTER - MinX - (CENTER_EDGE * 4 / 3), TEXT_DIMENSION)
    this.DimensioneTesto     = TEXT_DIMENSION
    this.ShiftGrafico        = GRAPH_SHIFT
    this.EdgeGrafico         = CENTER_EDGE
    let FirstPositionX       = CENTER - CENTER_EDGE - GRAPH_SHIFT
    let SecondPositionX      = CENTER + CENTER_EDGE - GRAPH_SHIFT
    this.__Context.clearRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = this.Background
    this.__Context.fillRect(0, 0, this.__Canvas.width, this.__Canvas.height)
    this.__Context.fillStyle = 'transparent'
    this.AggiustaValoriProfondita()
    this.CompilaColonnaPacker(FirstPositionX, SecondPositionX, TEXT_DIMENSION) //scritte m pc e le bande nere e descrizione
    this.DrawLineeOrizzontali(FirstPositionX, SecondPositionX) //livello dell'acqua
    
    this.__VisualizzaValoriIngrandito()
    
    this.CompilaTestoPiezometro(FirstPositionX, SecondPositionX, MaxX, CENTER_EDGE, TEXT_DIMENSION) //Righe angolo retto con numeri
    this.__DeleteTextOverboard(MinX, MaxX, MinY)
    this.DrawAllBorders()
    this.__DrawGrid(MinX, MaxX)
    // this.DrawYQuote()
    this.__DrawLeftSideLabels()
    this.__DrawBottomSideLabels()
    if(this.ListaPiezometri[0] != undefined)
      this.DrawColonnaPacker(FirstPositionX, SecondPositionX, MinY, MaxY) //Colonna centrale
  }
  __DeleteTextOverboard(MinX, MaxX, MinY)
  {
    this.__Context.save()
    this.__Context.fillStyle = this.Background
    this.__Context.fillRect(MinX, MinY, MaxX, 15)
    this.__Context.restore()
    return 
  }
  __GetDimensioneShift(Center, TEXT_DIMENSION)
  {
    let DimensioneMassima = 0
    this.__Context.save()
    let FontSize = this.AxisX.FontSize * TEXT_DIMENSION
    this.__Context.font = this.__GetFont(FontSize * 0.75, this.AxisX.FontType) 
    for(let i = 0; i < this.ListaPiezometri.length; i++)
    {
      let Piezometro = this.ListaPiezometri[i]
      if (DimensioneMassima < this.__Context.measureText(Piezometro.PressionePiezometro + '  ').width)
      {
        DimensioneMassima = this.__Context.measureText(Piezometro.PressionePiezometro + '  ').width
      }
    }
    this.__Context.restore()

    return (Center - DimensioneMassima)
  }

  HighlightMarkup(XCoord, YCoord)
  {
    let ListaMarkup = [];
    let LastMarkup = null
    for (let i = 0; i < this.ListaPiezometriVisibili.length; i++)
    {
      //let Trovato = false
      let Points = this.ListaPiezometriVisibili[i]

      let SinglePoint = {
                          X : (this.AxisX.Min + this.AxisX.Max) / 2,
                          Y : Points.PosizionePiezometro
                        }
      let XPoint = this.__GetXPixelsFromRealUdm(SinglePoint.X) - this.ShiftGrafico
      let YPoint = this.__GetYPixelsFromRealUdm(SinglePoint.Y)     

      if (XPoint - this.MarkupWidth / 2 <= XCoord && XPoint + this.MarkupWidth / 2 >= XCoord &&
          YPoint - this.MarkupWidth / 2 <= YCoord && YPoint + this.MarkupWidth / 2 >= YCoord && 
          Points.ScritteVisibili)
      {        
        //Trovato = true
        if (Points.LastMarkup != SinglePoint)
        {            
          if (Points.LastMarkup != null)
          {
            this.Paint(false)
          } 
          this.__DrawSingleMarkup(SinglePoint, Points.__Markup, Points.__MarkupHighlighted, true)
          Points.LastMarkup = SinglePoint  
        }
        LastMarkup = Points.LastMarkup
        LastMarkup.Coords = {}
        LastMarkup.Coords.X = XPoint
        LastMarkup.Coords.Y = YPoint
        LastMarkup.Hint = {}
        LastMarkup.Hint.Data = Points.Data
        LastMarkup.Hint.Modulo = Points.NumeroPiezometro
        LastMarkup.Hint.PrettyDate = Points.Data
        LastMarkup.Hint.Profondita = Points.PosizionePiezometro
        LastMarkup.Hint.PressionePiezometro = Points.PressionePiezometro
        //LastMarkup.Hint.ProfonditaPiezometro = Points.Profondita
        //break
        ListaMarkup.push(LastMarkup)
      }

      if (Points.LastMarkup != null)
      {
        this.Paint(false)
        Points.LastMarkup = null
      }
      // if(Trovato) 
      //   break
    }
    
    //return LastMarkup
    return ListaMarkup
  }
  
  HighlightMarkupTriangle(XCoord, YCoord, MarginTop, MarginBot, AltezzaCanvas)
  {
    
    let MinX                 = this.__GetXPixelsFromRealUdm(this.AxisX.Min)
    let MaxX                 = this.__GetXPixelsFromRealUdm(this.AxisX.Max)
    const CENTER             = (MinX + MaxX) / 2    
    const CENTER_EDGE        = (MinX + MaxX) / 32
    const TEXT_DIMENSION     = 1
    const GRAPH_SHIFT        = this.__GetDimensioneShift(CENTER - MinX - (CENTER_EDGE * 4 / 3), TEXT_DIMENSION)
    this.ShiftGrafico        = GRAPH_SHIFT
    this.EdgeGrafico         = CENTER_EDGE

    let Indice = 1
    
    let LastMarkup = null
    for (let i = 0; i < this.ListaPiezometriVisibili.length; i++)
    {
      let Trovato      = false
      let MostraMarkup = false
      let Points       = this.ListaPiezometriVisibili[i]
      let SinglePoint  = {
                           X : CENTER,
                           Y : Points.Profondita
                         }
      let CoordinataXPartenza = SinglePoint.X + this.EdgeGrafico - this.ShiftGrafico;
      let Step = (MaxX - CoordinataXPartenza) / (this.ListaPiezometriVisibili.length + 1)
      
      let XPoint             = CoordinataXPartenza + (Step * Indice)
      let YPoint             = this.__GetYPixelsFromRealUdm(SinglePoint.Y) > MarginTop ? this.__GetYPixelsFromRealUdm(SinglePoint.Y) : MarginTop
      let AltezzaTriangolo   = this.__Context.measureText("\u25BC").actualBoundingBoxAscent + this.__Context.measureText("\u25BC").actualBoundingBoxDescent
      let LunghezzaTriangolo = this.__Context.measureText("\u25BC").actualBoundingBoxRight + this.__Context.measureText("\u25BC").actualBoundingBoxLeft
      let PositionPressione  = this.__GetYPixelsFromRealUdm(Points.PosizionePiezometro)
      let YCoordProfondita   = this.__GetYPixelsFromRealUdm(Points.Profondita)
      
      if (PositionPressione > (AltezzaCanvas - MarginBot))
      {
        PositionPressione = AltezzaCanvas - MarginBot
        if (PositionPressione < YCoordProfondita)
          MostraMarkup = true
      }
      if (YCoordProfondita < MarginTop)
      {
        YCoordProfondita = MarginTop
        if (YCoordProfondita > PositionPressione)
          MostraMarkup = true
      }

      if (XPoint - LunghezzaTriangolo / 2 <= XCoord && XPoint + LunghezzaTriangolo / 2 >= XCoord &&
          YPoint - AltezzaTriangolo <= YCoord && YPoint >= YCoord &&
          !MostraMarkup &&
          Points.ScritteVisibili)
      {   
        Trovato = true
        if (Points.LastMarkup != SinglePoint)
        {            
          if (Points.LastMarkup != null)
          {
            this.Paint(false)
          } 
          this.__DrawSingleMarkupTriangle(SinglePoint, Points.__Markup, Points.__MarkupHighlighted, Indice, Step, YPoint)
          Points.LastMarkup = SinglePoint  
        }
        LastMarkup = Points.LastMarkup
        LastMarkup.Coords = {}
        LastMarkup.Coords.X = XPoint
        LastMarkup.Coords.Y = YPoint
        LastMarkup.Hint = {}
        LastMarkup.Hint.Data = Points.Data
        LastMarkup.Hint.Modulo = Points.NumeroPiezometro
        LastMarkup.Hint.PrettyDate = Points.Data
        LastMarkup.Hint.Profondita = Points.PosizionePiezometro
        LastMarkup.Hint.PressionePiezometro = Points.PressionePiezometro
        // LastMarkup.Hint.ProfonditaPiezometro = Points.Profondita
        break
      }

      if (!Trovato && Points.LastMarkup != null)
      {
        this.Paint(false)
        Points.LastMarkup = null
      }
      if(Trovato) 
        break

      Indice += 1
    }
    return LastMarkup
  }

  __DrawSingleMarkupTriangle(SinglePoint, Markup, MarkupHighlighted, Indice, Step, YPoint)
  {
    if (MarkupHighlighted == null || MarkupHighlighted == undefined)
      MarkupHighlighted = this.__MarkupHighlighted    
    if (Markup == null || Markup == undefined)
      Markup = this.__Markup
    
    let CoordinataXPartenza = SinglePoint.X + this.EdgeGrafico - this.ShiftGrafico;
      
    let CoordinataXCalcolata  = CoordinataXPartenza + (Step * Indice)
    this.__Context.fillStyle = 'red'
    let SimboloTriangolo = "\u25BC"
    // this.__Context.font = this.__GetFont(this.AxisX.FontSize * this.DimensioneTesto * 0.75, this.AxisX.FontType)
    this.__Context.font = this.__GetFont(10, this.AxisX.FontType)
    this.__Context.fillText(SimboloTriangolo, CoordinataXCalcolata + (this.__Context.measureText(SimboloTriangolo).width / 2), YPoint)
  }

  __DrawSingleMarkup(SinglePoint, Markup, MarkupHighlighted, Highlighted)
  {
    if (MarkupHighlighted == null || MarkupHighlighted == undefined)
      MarkupHighlighted = this.__MarkupHighlighted    
    if (Markup == null || Markup == undefined)
      Markup = this.__Markup
    this.__Context.beginPath()
    this.__Context.fillStyle = 'red'
    this.__Context.arc(this.__GetXPixelsFromRealUdm(SinglePoint.X) - this.ShiftGrafico,
                       this.__GetYPixelsFromRealUdm(SinglePoint.Y),
                       this.MarkupWidth / 2 - (Highlighted ? 0.5 : 0),
                       0,
                       2 * Math.PI)
    this.__Context.fill()
  }

  SetMarkup(NewMarkup, NewMarkupHighlighted, OnSuccess = null)
  {
    if (NewMarkup != null)
    {
      this.__Markup = new Image()
      this.__MarkupHighlighted = new Image()
      this.__Markup.onload = () => {                                
                                    this.__MarkupHighlighted.src = NewMarkupHighlighted   
                                   }
      this.__MarkupHighlighted.onload = () => {
                                                if (OnSuccess != null)
                                                  OnSuccess()
                                              }
      this.__Markup.src = NewMarkup
    }
  }

  AggiustaValoriProfondita()
  {
    for (let i = 0; i < this.ListaPacker.length; i++)
    {
      let LSPacker = this.ListaPacker[i]
      if (LSPacker.DallaProfondita < LSPacker.AllaProfondita)
      {
        let ProfonditaTemp       = LSPacker.DallaProfondita
        LSPacker.DallaProfondita = LSPacker.AllaProfondita
        LSPacker.AllaProfondita  = ProfonditaTemp
      }
    }
  }

  DrawAllBorders()
  {
    this.__Context.beginPath()
    this.__Context.strokeStyle = this.AxisX.Color
    this.__Context.setLineDash(this.AxisX.PenStyle)
    this.__Context.moveTo(this.__Margins.Left, this.__Margins.Top)
    this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Margins.Top)
    this.__Context.lineTo(this.__Canvas.width - this.__Margins.Right, this.__Canvas.height - this.__Margins.Bottom)
    this.__Context.lineTo(this.__Margins.Left, this.__Canvas.height - this.__Margins.Bottom) 
    this.__Context.lineTo(this.__Margins.Left, this.__Margins.Top)
    this.__Context.stroke()
  }

  DrawYQuote()
  {
    this.__Context.beginPath()
    let CurrentNotch = 0
    while (this.AxisY.Min > CurrentNotch)
    {      
      let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
      if( StartPx >= this.__Margins.Top - 1)
        this.__DrawYAxisLabel(CurrentNotch)
      CurrentNotch += this.AxisY.NotchDim
    }
    this.__Context.font = this.__GetFont(this.AxisX.FontSize, this.AxisX.FontType)
  }

  DrawColonnaPacker(FirstPositionX, SecondPositionX, MinY, MaxY)
  {
    this.__Context.beginPath()
    this.__Context.moveTo(FirstPositionX, MinY)
    this.__Context.lineTo(FirstPositionX, MaxY)
    this.__Context.moveTo((FirstPositionX + SecondPositionX) / 2, MinY)
    this.__Context.lineTo((FirstPositionX + SecondPositionX) / 2, MaxY)
    this.__Context.moveTo(SecondPositionX, MinY)
    this.__Context.lineTo(SecondPositionX, MaxY)

    if(this.DatiSopraLivelloCampagna && this.Ingrandito)
    {
      this.__Context.moveTo(FirstPositionX, MaxY)
      this.__Context.lineTo(SecondPositionX, MaxY)
    }
    this.__Context.stroke()
  }

  __DrawGrid(MinX, MaxX)
  {
    this.AxisY.NotchPenStyle = [5,5]
    // this.__DrawYNotches(MinX, MaxX)
    this.__DrawYPiezoNotches(MinX, MaxX)
    this.AxisY.NotchPenStyle = [0,0]
    this.__Context.setLineDash(this.AxisY.NotchPenStyle) 
  }

  __DrawYPiezoNotches(MinX, MaxX)
  {
    let CurrentNotch = this.CalcolaProfonditaMassimaPiezometri()
    let Max = this.AxisY.Max
    
    this.__Context.setLineDash(this.AxisY.NotchPenStyle)    
    this.__Context.lineWidth = this.AxisY.NotchPenWidth 
    this.__Context.beginPath()
  
    if(this.AxisY.Inverted)
    {
      Max = this.AxisY.Min
      this.__DrawYAxisLabel(this.AxisY.Max, true)

      while (CurrentNotch <= Max)
      {
        let StartPx = this.__GetYPixelsFromRealUdm(CurrentNotch)
        if(StartPx >= this.__Margins.Top)
        {
          this.__DrawYAxisLabel(CurrentNotch, true)
          this.__Context.moveTo(MinX, StartPx)
          this.__Context.lineTo(MaxX, StartPx)
        }
        
        CurrentNotch += this.AxisY.NotchDim
      }
    }

    this.__Context.stroke()
  }

  CalcolaProfonditaMassimaPiezometri()
  {
    let ProfonditaMassima = 0
    if(this.ListaPiezometri[0] != undefined)
      ProfonditaMassima = this.ListaPiezometri[0].Profondita * -1

    for(let i = 1; i < this.ListaPiezometri.length; i++)
    {
      let Profondita = this.ListaPiezometri[i].Profondita * -1

      if(Profondita > ProfonditaMassima)
      {
        ProfonditaMassima = Profondita
      }
    }
    ProfonditaMassima = TZMathFunct.GetMultiplo(ProfonditaMassima, this.AxisY.NotchDim, 'Eccesso')
    if(ProfonditaMassima > 0)
      this.DatiSopraLivelloCampagna = true
    let Result = ProfonditaMassima > 0 ? (ProfonditaMassima * -1) : 0
    return Result
  }

  CompilaColonnaPacker(FirstPositionX, SecondPositionX, TEXT_DIMENSION)
  {
    this.__Context.textAlign = 'left'
    for (let i = 0; i < this.ListaPacker.length; i++)
    {
      let LSPacker = this.ListaPacker[i]
      let FuoriDallaTabella = false
      let ShowPacker = true
      let DallaProfondita = this.__GetYPixelsFromRealUdm(LSPacker.DallaProfondita)
      let AllaProfondita  = this.__GetYPixelsFromRealUdm(LSPacker.AllaProfondita)
      this.__Context.fillStyle = LSPacker.Colore
      if (LSPacker.DallaProfondita < LSPacker.AllaProfondita)
      {
        let ProfonditaTemp       = LSPacker.DallaProfondita
        LSPacker.DallaProfondita = LSPacker.AllaProfondita
        LSPacker.AllaProfondita  = ProfonditaTemp
      }
      if (DallaProfondita > (this.__Canvas.height - this.__Margins.Bottom))
        DallaProfondita = this.__Canvas.height - this.__Margins.Bottom
      if (DallaProfondita < this.__Margins.Top || AllaProfondita > (this.__Canvas.height - this.__Margins.Bottom))
        FuoriDallaTabella = true

      if (AllaProfondita < this.__Margins.Top)
      {
        AllaProfondita = this.__Margins.Top
        ShowPacker = false
      }
      if (!FuoriDallaTabella)
      {
        this.__FillColonnaPacker(FirstPositionX, SecondPositionX, DallaProfondita, AllaProfondita)
        if (ShowPacker)
          this.__PackerText(LSPacker, FirstPositionX, AllaProfondita, TEXT_DIMENSION)
      }
    }
  }

  DrawLineeOrizzontali(FirstPositionX, SecondPositionX)
  {
    this.__Context.textAlign = 'left'
    for (let i = 0; i < this.ListaPacker.length; i++)
    {
      let LSPacker = this.ListaPacker[i]
      let FuoriDallaTabella = false
      let AllaProfondita  = this.__GetYPixelsFromRealUdm(LSPacker.AllaProfondita)
      this.__Context.fillStyle = LSPacker.Colore
      if (AllaProfondita < this.__Margins.Top || AllaProfondita > (this.__Canvas.height - this.__Margins.Bottom))
        FuoriDallaTabella = true
      if (!FuoriDallaTabella)
      {
        this.__Context.strokeStyle = '#0088cc'
        this.__Context.beginPath()
        if (AllaProfondita != this.__Margins.Top)
          {
            this.__Context.moveTo(FirstPositionX, AllaProfondita)
            this.__Context.lineTo(SecondPositionX, AllaProfondita)
          }
        this.__Context.stroke()
        this.__Context.strokeStyle = this.AxisX.Color
      }
    }
  }

  __MostrakPa()
  {
    let UltimaData = null
    let Esito = true

    if(this.ListaPiezometriVisibili.length == 0 || !this.ListaPiezometriVisibili)
      Esito = false

    if(this.ListaPiezometriVisibili.length > 0 && this.ListaPiezometriVisibili)
    {
      UltimaData = this.ListaPiezometriVisibili[0].Data

      let DateUguali = this.ListaPiezometriVisibili.every(Piezometro => Piezometro.Data === UltimaData)
      
      if(!DateUguali)
      {
        let GruppoDate = {}

        this.ListaPiezometriVisibili.forEach(
                                              Piezometro => {
                                                              if(!GruppoDate[Piezometro.Data])
                                                                GruppoDate[Piezometro.Data] = []

                                                              GruppoDate[Piezometro.Data].push(Piezometro)

                                                            }

                                            )
        let DateConScritteVisibili = Object.keys(GruppoDate).filter(
                                                                     Data => GruppoDate[Data].some(Piezometro => Piezometro.ScritteVisibili)
                                                                   )
        if(DateConScritteVisibili.length != 1)
          Esito = false
      }
      
    }

    return Esito
  }

  __SceltaColore()
  {
    let UltimaData = this.UltimaData.Data
    let Esito = false

    Esito = this.ListaPiezometriVisibili.every(Piezometro => Piezometro.Data === UltimaData)

    return Esito
  }

  __VisualizzaValoriIngrandito()
  {
    this.ListaPiezometriVisibili = []

    if(this.ListaPiezometri && this.ListaPiezometri.length > 0)
    {
      if(!this.Ingrandito)
      {
        let UltimaData = this.ListaPiezometri[0].Data === this.UltimaData.Data ? this.UltimaData.Data : this.ListaPiezometri[0].Data
        this.ListaPiezometri.forEach(
                                      (Piezometro) => {
                                                        if(Piezometro.Data === UltimaData)
                                                          this.ListaPiezometriVisibili.push(Piezometro)
                                                      }
                                    )
      }
      else
      {
        this.ListaPiezometriVisibili = this.ListaPiezometri
      }
    }
  }

  CompilaTestoPiezometro(FirstPositionX, SecondPositionX, MaxX, CENTER_EDGE, TEXT_DIMENSION)
  {
    this.__Context.textAlign = 'left'
    let Indice = 1
    //let Step = (MaxX - SecondPositionX) / (this.ListaPiezometri.length + 1)
    let Step = (MaxX - SecondPositionX) / (this.ListaPiezometriVisibili.length + 1)
    // for (let i = 0; i < this.ListaPiezometri.length; i++)
    // {
    //   let LSPiezometro = this.ListaPiezometri[i]
    //   //this.__Context.fillStyle = LSPiezometro.Colore
      
    //   if (LSPiezometro.ScritteVisibili)
    //   {
    //     this.__ProfonditaText(LSPiezometro, FirstPositionX, SecondPositionX, Indice, Step, CENTER_EDGE, TEXT_DIMENSION)
    //     Indice += 1
    //   }
    // }
    
    for (let i = 0; i < this.ListaPiezometriVisibili.length; i++)
    {
      let LSPiezometro = this.ListaPiezometriVisibili[i]
      //this.__Context.fillStyle = LSPiezometro.Colore
      
      if (LSPiezometro.ScritteVisibili && !LSPiezometro.MostraSoloHint)
      {
        this.__ProfonditaText(LSPiezometro, FirstPositionX, SecondPositionX, Indice, Step, CENTER_EDGE, TEXT_DIMENSION)
        Indice += 1
      }
    }
  }

  __ProfonditaText(LSPiezometro, FirstPositionX, SecondPositionX, Indice, Step, CENTER_EDGE, TEXT_DIMENSION)
  {
    let ProfonditaUdm          = "m pc"
    //let LabelProfonditaSimbolo = "\u25BC"
    let LabelPressioneSimbolo  = "\u25CF"
    let OverflowText           = false
    const ROW_HEIGHT           = this.AxisY.FontSize * 0.65 * TEXT_DIMENSION
    let ShowRiga               = true
    let PositionPressione      = this.__GetYPixelsFromRealUdm(LSPiezometro.PosizionePiezometro)
    let YCoordProfondita       = this.__GetYPixelsFromRealUdm(LSPiezometro.Profondita)
    //let XCoordTextPosition     = SecondPositionX + CENTER_EDGE * Indice * 1.2
    let XCoordTextPosition     = SecondPositionX + (Step * Indice)

    let FontSize = this.AxisX.FontSize * TEXT_DIMENSION

    // Serviva a far adattare il testo allo zoom
    // if (this.PiezoFontZoom != null)
    // {
    //   FontSize   *= this.PiezoFontZoom
    //   ROW_HEIGHT *= this.PiezoFontZoom
    // }
    this.__Context.font = this.__GetFont(FontSize * 0.75, this.AxisX.FontType) 

    let ColoreScelto = !this.__SceltaColore() ? LSPiezometro.Colore : this.COLORE_AZZURRO
    //let ColoreScelto = LSPiezometro.Colore
    //serviva a non fare sbordare le righe dal canvas
    // if (XCoordTextPosition < MaxX)
    // {
      let XCoordEndLinePosition  = FirstPositionX - (CENTER_EDGE / 3)
      //this.__Context.fillStyle   = 'black'
      this.__Context.fillStyle   = ColoreScelto
      //this.__Context.strokeStyle = LSPiezometro.Colore
      this.__Context.strokeStyle = ColoreScelto
      if (YCoordProfondita < (this.__Canvas.height - this.__Margins.Bottom) && YCoordProfondita > this.__Margins.Top)
      {
        this.DrawSimbol(this.LabelSimbolo(XCoordTextPosition, YCoordProfondita))
        //this.__Context.fillText(LabelProfonditaSimbolo, XCoordTextPosition - (this.__Context.measureText(LabelProfonditaSimbolo).width / 2) - 0.25, YCoordProfondita)
        if(LSPiezometro.MostraInfoPiezometro)
        { 
          let HEIGHT_TEXT = this.__Context.measureText('0').actualBoundingBoxAscent + this.__Context.measureText('0').actualBoundingBoxDescent;
          this.__Context.fillText(ProfonditaUdm, XCoordTextPosition - (this.__Context.measureText(ProfonditaUdm).width / 2), YCoordProfondita - ROW_HEIGHT - 1)
          if(LSPiezometro.Profondita <= 0)
            this.__Context.fillText("+" + (LSPiezometro.Profondita * -1).toFixed(2), XCoordTextPosition - (this.__Context.measureText("+" + (LSPiezometro.Profondita * -1).toFixed(2)).width / 2), YCoordProfondita - (ROW_HEIGHT * 2) - HEIGHT_TEXT/3)
          else
            this.__Context.fillText((LSPiezometro.Profondita * -1).toFixed(2), XCoordTextPosition - (this.__Context.measureText((LSPiezometro.Profondita * -1).toFixed(2)).width / 2), YCoordProfondita - (ROW_HEIGHT * 2) - HEIGHT_TEXT/3 )
        }
      }
      else
      {
        OverflowText = true
      }
      if (PositionPressione > (this.__Canvas.height - this.__Margins.Bottom))
      {
        PositionPressione = this.__Canvas.height - this.__Margins.Bottom
        if (PositionPressione < YCoordProfondita)
          ShowRiga = false
      }
      if (YCoordProfondita < this.__Margins.Top)
      {
        YCoordProfondita = this.__Margins.Top
        if (YCoordProfondita > PositionPressione)
          ShowRiga = false
      }
      if(ShowRiga)
      {
        this.__Context.beginPath()
        this.__Context.moveTo(XCoordTextPosition, YCoordProfondita - 1 )
        this.__Context.lineTo(XCoordTextPosition, PositionPressione)
        this.__Context.stroke()  
        if(OverflowText)
        {
          this.DrawSimbol(this.LabelSimbolo(XCoordTextPosition, this.__Margins.Top), this.COLORE_AZZURRO)
          //this.__Context.fillText(LabelProfonditaSimbolo, XCoordTextPosition - (this.__Context.measureText(LabelProfonditaSimbolo).width / 2) - 0.25, this.__Margins.Top)
          if(LSPiezometro.MostraInfoPiezometro)
          {
            this.__Context.fillText(ProfonditaUdm, XCoordTextPosition - (this.__Context.measureText(ProfonditaUdm).width / 2), this.__Margins.Top - ROW_HEIGHT - 1)

            if(LSPiezometro.Profondita <= 0)
            {
              this.__Context.fillText("+" + (LSPiezometro.Profondita * -1), XCoordTextPosition - (this.__Context.measureText("+" + (LSPiezometro.Profondita * -1)).width / 2), this.__Margins.Top - 2 * ROW_HEIGHT - 1.5)
            }
            else
            {
              this.__Context.fillText((LSPiezometro.Profondita * -1), XCoordTextPosition - (this.__Context.measureText(LSPiezometro.Profondita * -1).width / 2), this.__Margins.Top - 2 * ROW_HEIGHT - 1.5)
            }
          }
            
        }
      }
      if(PositionPressione < (this.__Canvas.height - this.__Margins.Bottom) && PositionPressione > this.__Margins.Top)
      {
        this.__Context.fillStyle   = 'black'
        this.__Context.beginPath()
        this.__Context.moveTo(XCoordTextPosition, PositionPressione)
        this.__Context.lineTo(XCoordEndLinePosition, PositionPressione)
        this.__Context.stroke()
        
        if(this. __MostrakPa())
        {
          let PressioneUdm   = " kPa"
          var AltezzaLettera = this.__Context.measureText(LSPiezometro.PressionePiezometro);
          var txtHLettera = AltezzaLettera.actualBoundingBoxAscent + AltezzaLettera.actualBoundingBoxDescent;
          this.__Context.fillText(LSPiezometro.PressionePiezometro, XCoordEndLinePosition - (this.__Context.measureText(LSPiezometro.PressionePiezometro + " ").width), PositionPressione + txtHLettera /2)
          this.__Context.fillText(PressioneUdm, XCoordEndLinePosition - (this.__Context.measureText(LSPiezometro.PressionePiezometro + "  ").width), PositionPressione + 2 * txtHLettera)
          // this.__Context.fillText(PressioneUdm, XCoordEndLinePosition - (this.__Context.measureText(PressioneUdm + " ").width), PositionPressione + txtHLettera)
        }
        
        var AltezzaLabelPressioneSimbolo = this.__Context.measureText(LabelPressioneSimbolo);
        var txtHPressioneSimbolo = AltezzaLabelPressioneSimbolo.actualBoundingBoxAscent + AltezzaLabelPressioneSimbolo.actualBoundingBoxDescent;
        this.__Context.fillText(LabelPressioneSimbolo, (FirstPositionX + SecondPositionX) / 2 - this.__Context.measureText(LabelPressioneSimbolo).width / 2 , PositionPressione + txtHPressioneSimbolo / 2)
      }
  }

  __FillColonnaPacker(FirstPositionX, SecondPositionX, DallaProfondita, AllaProfondita)
  {
    this.__Context.beginPath()
    this.__Context.moveTo(FirstPositionX, DallaProfondita)
    this.__Context.lineTo(FirstPositionX, AllaProfondita)
    this.__Context.lineTo(SecondPositionX, AllaProfondita)
    this.__Context.lineTo(SecondPositionX, DallaProfondita)
    this.__Context.lineTo(FirstPositionX, DallaProfondita)
    this.__Context.fill()
  }

  __PackerText(LSPacker, FirstPositionX, AllaProfondita, TEXT_DIMENSION)
  { 
    this.__Context.save()
    this.__Context.fillStyle = this.COLORE_DESCRIZIONE_PACKER

    let FontSize = this.AxisX.FontSize * TEXT_DIMENSION
    // Serviva a far adattare il testo allo zoom
    // if (this.PiezoFontZoom != null)
    // {
    //   FontSize   *= this.PiezoFontZoom
    // }
    this.__Context.font = this.__GetFont(FontSize * 0.75, this.AxisX.FontType)
    this.__Context.font = this.__GetFont(FontSize, this.AxisX.FontType)
    let LabelPosition = FirstPositionX - this.__Context.measureText(LSPacker.Descrizione + " ").width
    
    let AltezzaDescrizione = (this.__Context.measureText(LSPacker.Descrizione + " ").actualBoundingBoxAscent + 
                             this.__Context.measureText(LSPacker.Descrizione + " ").actualBoundingBoxDescent)

    this.__Context.fillText(LSPacker.Descrizione + " ", LabelPosition, AllaProfondita + AltezzaDescrizione / 2)
    // Vecchia proporzione del font size
    // this.__Context.font = this.__GetFont(FontSize * 0.6, this.AxisX.FontType)
    this.__Context.font = this.__GetFont(FontSize * 0.75, this.AxisX.FontType)
    
    // LabelPosition = FirstPositionX - this.__Context.measureText(LSPacker.AllaProfondita + " m pc. ").width
    // var AltezzaLettera = this.__Context.measureText(LSPacker.AllaProfondita + " m pc. ");
    // var txtHLettera = AltezzaLettera.actualBoundingBoxAscent + AltezzaLettera.actualBoundingBoxDescent;
    // this.__Context.fillText(LSPacker.AllaProfondita + " m pc. ", LabelPosition , AllaProfondita + txtHLettera * 1.20)

    this.__Context.restore()
  }

  LabelSimbolo(CoordX, Profondita)
  {
    let Simbolo = []

    let XCoordCenter    = CoordX
    let CoordXIniziale = XCoordCenter - 1.5
    let CoordYIniziale = Profondita - 1

    let LunghezzaLinea = XCoordCenter + 1.5
    let Step = 2

    for(let i = 0; i < 4; i++)
    {
      Simbolo.push({
                     X1 : CoordXIniziale - (Step * i),
                     Y1 : CoordYIniziale - (Step * i),
                     X2 : (LunghezzaLinea) + (Step * i),
                     Y2 : CoordYIniziale - (Step * i)
                   })

    }

    return Simbolo

  }

  DrawSimbol(Simbolo, Colore)
  {
    Simbolo.forEach(Coordinata => {
                                    this.__Context.beginPath()
                                    this.__Context.moveTo(Coordinata.X1, Coordinata.Y1);
                                    this.__Context.lineTo(Coordinata.X2, Coordinata.Y2);
                                    this.__Context.strokeStyle = Colore
                                    this.__Context.lineWidth = 1;
                                    this.__Context.stroke();
                                  })
  }
}


